<template>
  <template v-if="this.$store.state.vMode == 0">

    <template v-for="time in times" :key="time">
      <div class="time-column-vertical">
        <div>{{ time }}</div>
        <div> - </div>
        <div>{{this.toTime(time)}}</div>
      </div>
    </template>
  </template>
  <template v-else>
    <div class="timeline top-wrapper" :class="{ loading: $store.state.loading }">
      <div class="timeline-wrap wrapper-scroll mousescroll"
           @mousedown="mousedown"
           @mouseup="mouseup"
           @mouseleave="mouseup"
           @mousemove="mouseMove"
           @scroll="scrollHandler"
           ref="mscroll"
      >
        <span class="l-arrow" @click="sLeft"></span><span class="r-arrow" @click="sRight"></span>
        <span class="time-column" v-for="time in times" :key="time">
            {{ time }}
          </span>
      </div>

    </div>
  </template>
</template>

<script>

export default {
  name: 'TimeLine',
  emits: ['timeline-scroll'],
  props: {
    startTime: String,
    endTime: String
  },
  data() {
    return {
      times: [],
      // isLoading: true,
      minHour: 10,
      maxHour: 22,
      speed: 1, // Скорость скролла.
      left: 0, //нажали мышку - сохраняем положение скролла
      drag: false,
      coorX: 0, // нажали мышку - сохраняем координаты.
      startTimeLocal: "10:00",
      endTimeLocal: "22:00"
    }
  },

  updated() {
  },
  // watch: {
  //   timeRange: function () {
  //     // for (var name in data){
  //     //   this[name] = data[name];
  //     // }
  //     // console.log('timeRange')
  //
  //     this.buildData()
  //     // this.isLoading =  false;
  //   },
  // },

  created() {
    this.startTimeLocal = this.startTime ? this.startTime : this.startTimeLocal
    this.endTimeLocal = this.endTime ? this.endTime : this.endTimeLocal
    this.buildData()
  },
  mounted() {
    if(this.$store.state.vMode == 1){
      // фейковые движения, для срабатывания показа стрелочки прокрутки
      this.$refs.mscroll.scrollLeft = 1 //# включить
      this.$refs.mscroll.scrollLeft = 0 //# включить
    }
  },
  computed: {},
  methods: {
    toTime(time){
      let h = Number(time.split(':')[0]);
      let m = Number(time.split(':')[1]);
      let res = m > 0 ? h+1:h;
      res += ":";
      res += m > 0 ? "00":"30";
      return res ;
    },
    slider(slider, step, period) {
      const startTime = Date.now()
      const startLeft = slider.scrollLeft
      const render = () => {
        const dt = Date.now() - startTime
        if (dt < period) {
          slider.scrollLeft = startLeft + step * dt / period
          requestAnimationFrame(render)
        }
      }
      requestAnimationFrame(render)
    },

    itemScroll(child, left = true) {
      let item = child.closest('.mousescroll');
      let tracksW = item.scrollWidth;
      let elemW = item.clientWidth;
      tracksW = tracksW > elemW ? elemW * 2 : tracksW;
      let step = left ? tracksW / 3 : -tracksW / 3
      this.slider(item, step, 500)
    },
    sLeft({currentTarget}) {
      this.itemScroll(currentTarget, false)
    },
    sRight({currentTarget}) {
      this.itemScroll(currentTarget, true)
    },
    scrollHandler({currentTarget}) {

      let
          scrollLeft = Math.round(currentTarget.scrollLeft),
          scrollWidth = Math.round(currentTarget.scrollWidth),
          clientWidth = Math.round(currentTarget.clientWidth)

      if (scrollLeft < 5) {
        currentTarget.querySelector('.l-arrow').classList.remove('show');
      } else {
        currentTarget.querySelector('.l-arrow').classList.add('show');
      }
      if (scrollWidth == Math.round(scrollLeft + clientWidth)) {
        currentTarget.querySelector('.r-arrow').classList.remove('show');
      } else {
        currentTarget.querySelector('.r-arrow').classList.add('show');
      }
    },
    buildData() {

      let
          start = Number(this.startTimeLocal.split(':')[0]),
          startMinute = Number(this.startTimeLocal.split(':')[1]),
          end = Number(this.endTimeLocal.split(':')[0]),
          endMinute = Number(this.endTimeLocal.split(':')[1]),
          res = [];
      for (let $i = start; $i <= end; $i++) {
        if ($i == end && endMinute == 0){
          break;
        }
        if (($i == start && startMinute == 0) || $i != start) {
          res.push($i + ':00')
        }
        if (($i == end - 1 && endMinute == 0) || $i != end ) {
          res.push($i + ':30')
        }
      }
      this.times = res;
    },
    mousedown(e) {
      let el = e.currentTarget;
      this.drag = true
      this.coorX = e.pageX - el.offsetLeft;
      this.left = el.scrollLeft;

    },
    mouseup() {
      this.drag = false
    },
    mouseMove(e) {

      if (this.drag) {
        let el = e.currentTarget;
        let scroll = this.left - (e.pageX - el.offsetLeft - this.coorX) * this.speed;
        // console.log(e.pageX,el.offsetLeft)
        el.scrollLeft = scroll;
        // this.$emit('timeline-scroll',scroll)
      }

      // if (this.drag) {
      //   this.x = e.clientX;
      //   this.y = e.clientY;
      // }

      // console.log(event.clientX, event.clientY);
    }
  }
}
</script>
<style scoped>

.mousescroll {
  user-select: none;
  transition: all ease .4s;
}

.mousescroll:hover {
  background: #9fbf0022;

  cursor: move;
}

.mousescroll:hover .time-column {
  color: #BE8A5E !important;
}


.wrapper-scroll {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.wrapper-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.wrapper-scroll .scroll-y {
  display: none !important;
}

.timeline {
  background-color: #fff;
  height: 2rem;
  opacity: 1;
  transition: background-color ease .7s;
  will-change: transform;
}

.timeline-wrap {
  display: flex;
  transition: opacity ease .7s;
}

.timeline.loading > .timeline-wrap {
  opacity: 0;
}

.timeline.loading {
  background-color: #faf9f9;
}


/*.fade-enter-active,*/
/*.fade-leave-active {*/

/*  transition: opacity 0.2s ease;*/
/*}*/

/*.fade-enter-from,*/
/*.fade-leave-to {*/
/*  opacity: 0;*/
/*}*/


/*.timeline-wrap  {*/
/*  width: 100%;*/
/*  overflow-x: hidden;*/
/*  display: flex;*/
/*  transition: opacity ease .3s;*/
/*  margin-left: 250px;*/
/*}*/


.time-column {
  color: #555;
  font-size: .85rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 4rem;
  min-width: 4rem;
  height: 2rem;
}

.time-column:before {
  content: '';
  display: block;
  left: 0;
  width: 0;
  position: absolute;
  height: 100%;
  border-left: 1px solid #eee;
}

.time-column:nth-child(2n) {
  font-size: .7rem;
  color: #999;
}

.top-wrapper {
  top: 0;
  position: -webkit-sticky;
  position: sticky;
  z-index: 11;
  width: 100%;
  background: #fff;
  width: calc(100% - 250px);
  margin-left: 250px;
}


.r-arrow,
.l-arrow {
  background-color: #fff;
  position: absolute;
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 65%;
  width: 32px;
  height: 32px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23000000' class='bi bi-chevron-right' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E");
  right: 0px;
  top: 0px;
  transition: all ease .4s;
  z-index: 15;
  opacity: 0;
}

.r-arrow.show,
.l-arrow.show {
  opacity: 1;
}

.r-arrow:hover,
.l-arrow:hover {
  background-color: #ffeda3;
  cursor: pointer;
}

.l-arrow {
  transform: rotate(180deg);
  left: 0px
}

@media (max-width: 670px) {
  /*.timeline-wrap {*/
  /*  width: calc(100% - 120px);*/
  /*  margin-left: 120px;*/
  /*}*/
  .top-wrapper {
    width: calc(100% - 120px);
    margin-left: 120px;
  }
}

.time-column-vertical{
  position: relative;
  top:2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .9rem;
  margin-bottom: 2px;
  text-align: center;
  width: 100%;
  background: #eee;
  border-radius: 5px;
  height: 4rem;
  flex-direction: column;
  line-height: 0.8em;
  margin-right: 2px;
}

</style>
<script setup>
</script>
